"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddReviewV2Container = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const cotopaxi_1 = require("@as/cotopaxi");
const common_components_1 = require("@as-react/common-components");
const AddReviewForm_1 = require("../components/add-review/add-review-form/AddReviewForm");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../constants/i18nConstants");
const SessionSelector_1 = require("../redux/session/selectors/SessionSelector");
const ProductSelector_1 = require("../redux/product/selectors/ProductSelector");
const ReviewsApi_1 = tslib_1.__importDefault(require("../api/ReviewsApi"));
const ScrollUtil_1 = require("../util/ScrollUtil");
const AddReviewV2Container = ({ title, description }) => {
    const addReviewFormRef = (0, react_1.useRef)(null);
    const [showForm, setShowForm] = (0, react_1.useState)(false);
    const [showLoggedOffMessage, setShowLoggedOffMessage] = (0, react_1.useState)(false);
    const [submitted, setSubmitted] = (0, react_1.useState)(false);
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.product);
    const isMobile = (0, cotopaxi_1.useMediaQueryMatchesOnMobile)();
    const { defaultRequestParams, servicesEndpoint } = (0, common_components_1.useAemConfig)();
    const loggedIn = (0, react_redux_1.useSelector)((0, SessionSelector_1.makeGetLoggedInState)());
    const productId = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetProductDefaults)()).productId;
    const customerUUID = (0, react_redux_1.useSelector)((0, SessionSelector_1.makeGetUUID)());
    const customerName = (0, react_redux_1.useSelector)((0, SessionSelector_1.makeGetFirstName)());
    const onCancel = () => setShowForm(false);
    const onShowReviewForm = () => {
        setShowForm(loggedIn);
        setShowLoggedOffMessage(!showForm && !loggedIn);
    };
    const scrollToAddReview = () => {
        if (addReviewFormRef.current) {
            ScrollUtil_1.ScrollUtil.scrollToElement(addReviewFormRef.current, true);
        }
    };
    const addReview = (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ rating, advantages, disadvantages }) {
        const reviewData = {
            productId,
            customerUUID,
            reviewTitle: title,
            score: rating,
            reviewTextPositive: advantages,
            reviewTextNegative: disadvantages,
            customerName,
        };
        setSubmitting(true);
        if (customerUUID) {
            yield ReviewsApi_1.default.postReview(reviewData, defaultRequestParams, servicesEndpoint);
            setSubmitted(true);
            setSubmitting(false);
            setShowForm(false);
            scrollToAddReview();
        }
    });
    return ((0, jsx_runtime_1.jsxs)("div", { ref: addReviewFormRef, children: [!showForm && !submitted && ((0, jsx_runtime_1.jsxs)(cotopaxi_1.Box, { mobile: {
                    spacing: { paddingTop: 3, paddingBottom: 3, paddingLeft: 2, paddingRight: 2 },
                    theme: cotopaxi_1.BoxTheme.PRIMARY,
                }, children: [title && ((0, jsx_runtime_1.jsx)(cotopaxi_1.Text, { emphasized: true, type: cotopaxi_1.TextType.EXTRA_CONTENT, align: cotopaxi_1.TextAlign.CENTER, children: title })), description && ((0, jsx_runtime_1.jsx)(cotopaxi_1.Box, { mobile: { spacing: { paddingTop: 1, paddingBottom: 1.5 } }, tablet: { spacing: { paddingTop: 0.5, paddingBottom: 2 } }, children: (0, jsx_runtime_1.jsx)(cotopaxi_1.Text, { type: cotopaxi_1.TextType.CONTENT, align: cotopaxi_1.TextAlign.CENTER, children: description }) })), (0, jsx_runtime_1.jsx)(cotopaxi_1.Group, { align: cotopaxi_1.GroupAlign.CENTER, children: (0, jsx_runtime_1.jsx)(cotopaxi_1.Button, { fill: isMobile, onClick: onShowReviewForm, dataQA: "write_review", text: t('product.review.add.banner.cta') }) })] })), showForm && loggedIn && ((0, jsx_runtime_1.jsx)(AddReviewForm_1.AddReviewForm, { inline: true, addReview: addReview, onCancel: onCancel, submitting: submitting, boxTheme: cotopaxi_1.BoxTheme.PRIMARY })), showLoggedOffMessage && ((0, jsx_runtime_1.jsx)(cotopaxi_1.FeedbackMessage, { align: cotopaxi_1.FeedbackMessageAlign.CENTER, text: t('product.review.logged.off'), variant: cotopaxi_1.FeedbackMessageVariant.INFO })), submitted && ((0, jsx_runtime_1.jsx)(cotopaxi_1.FeedbackMessage, { align: cotopaxi_1.FeedbackMessageAlign.CENTER, text: t('product.review.add.banner.output.success'), variant: cotopaxi_1.FeedbackMessageVariant.POSITIVE }))] }));
};
exports.AddReviewV2Container = AddReviewV2Container;
